<ng-container>
  <div class="shipping-role-container" style="border-bottom: 1px solid #d9d9d9; font-size: 20px">
    <span class="shipping-role-container__header" [ngClass]="{ oldStyleTheme: isOldStyleTheme }">
      {{ "LABELS.SHIPPING_PROFILE_DEFINITIONS" | translate }}

      <span class="d-lg-none">
        <app-hint-tooltip-icon [hint]="'LABELS.SHIPPING_PROFILE_DEFINITIONS_DESCRIPTIONS' | translate"></app-hint-tooltip-icon>
      </span>
    </span>
    <app-hint-tooltip-icon *ngIf="isOldStyleTheme" [hint]="enumHintKey.shippingDefinitionsHint"></app-hint-tooltip-icon>
  </div>
  <div class="d-flex" [formGroup]="formGroup">
    <div class="shipping-role-container-form pr-0 pl-0" [ngClass]="{ 'col-12 col-lg-8': isShowDescription, 'col-12': !isShowDescription }">
      <span class="shipping-role-container-form__header">{{ "LABELS.WHICH_OPTION_DESCRIBES_BUSINESS" | translate }}</span>
      <app-control-wrapper [control]="formGroup.get('shippingRole')" [isShowHelper]="false">
        <div control-wrapper>
          <div class="shipping-role-container-form__option">
            <app-radio-button
              [id]="'shippingRole-buyer'"
              [value]="enumShippingRole.IMPORTER"
              [name]="'shippingRole'"
              [control]="formGroup.get('shippingRole')"
              [label]="'FORM_LABEL.BUYER' | translate"
            ></app-radio-button>
          </div>
          <div class="shipping-role-container-form__option">
            <app-radio-button
              [id]="'shippingRole-seller'"
              [value]="enumShippingRole.SHIPPER"
              [name]="'shippingRole'"
              [control]="formGroup.get('shippingRole')"
              [label]="'FORM_LABEL.SELLER' | translate"
            ></app-radio-button>
          </div>
          <div class="shipping-role-container-form__option">
            <app-radio-button
              [id]="'shippingRole-other'"
              [value]="enumShippingRole.OTHER"
              [name]="'shippingRole'"
              [control]="formGroup.get('shippingRole')"
              [label]="'FORM_LABEL.BOTH' | translate"
            ></app-radio-button>
          </div>
        </div>
      </app-control-wrapper>
    </div>
    <div class="d-none d-lg-block" [ngClass]="{ 'col-4': isShowDescription }" *ngIf="isShowDescription">
      <div class="shipping-role-container-description">
        <span>{{ "LABELS.SHIPPING_PROFILE_DEFINITIONS_DESCRIPTIONS" | translate }}</span>
      </div>
    </div>
  </div>
</ng-container>
